export enum GetWheelStateError {}

export const GetWheelStateErrorMessages = {};

export enum WheelSpinError {
  NotEnoughChance = 2,
}

export const WheelSpinErrorMessages = {
  [WheelSpinError.NotEnoughChance]: "شما شانس کافی برای چرخاندن گردونه ندارید!",
};
